import styled, { keyframes } from 'styled-components';

const ellipsesAnim = keyframes`
  from { opacity: 0; }
`;

const Ellipses = styled.span`
  --delay: calc(var(--i, 0) * 0.2s);
  animation: 1s var(--delay) ${ellipsesAnim} steps(2) infinite;
`;

const ellipsesArr = Array.from({ length: 3 }, () => null);
export default function LoadingEllipses() {
  return (
    <>
      {ellipsesArr.map((_, i) => (
        <Ellipses key={`ellipses-${i}`} style={{ '--i': i }}>
          .
        </Ellipses>
      ))}
    </>
  );
}
